import React from 'react';
import { CircleCheck, Info } from 'lucide-react';

/** A centred note about the conversation itself, not a turn in it. */
const ChatSystemMessage: React.FC<{ content: string }> = ({ content }) => {
  const isSuccess = content.startsWith('✅');
  const Icon = isSuccess ? CircleCheck : Info;

  return (
    <div className="mb-4 flex justify-center">
      <div className="flex items-center gap-2 rounded-lg border bg-muted/60 px-3 py-1.5">
        <Icon
          className={isSuccess ? 'size-4 shrink-0 text-success' : 'size-4 shrink-0 text-primary'}
          strokeWidth={2}
        />
        <p className="text-[13px]">{content.replace('✅ ', '')}</p>
      </div>
    </div>
  );
};

export default ChatSystemMessage;
